import React from "react";
import { useNavigate } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import LayoutComunicacion from "./comunicacion/LayoutComunicacion";

export default function IntranetComunicacionBuzonPage() {
    const navigate = useNavigate();

    const handleNavigate = (target, item = null) => {
        navigate(`/menu/intranet/comunicacion/${target}`, { state: { initialItem: item } });
    };

    return (
        <div className="intranet-red-theme">
            <LayoutComunicacion activeScreen="buzon" onNavigate={handleNavigate} />
        </div>
    );
}
